<div class="prelicense-banner" *ngIf="lgvUserSvc.IsPreLicensedAgent$ | async">
    <ng-template [ngIf]="!(lgvUserSvc.AgentSS$ | async)?.hasLoanReferral" [ngIfElse]="hasLoanReferral">
        <span>You are one step closer to getting licensed! Start a pre-approval today with your Concierge partner.</span>
        <a class="btn-outline" target="_blank"
            href="https://support.realfinity.io/hc/en-us/articles/34886862403732">
            How to Start a Pre-Approval
        </a>
    </ng-template>
    <ng-template #hasLoanReferral>
        <span>You are one step closer to providing mortgages to your clients and unlocking your loan commissions!</span>
        <a class="btn-outline" routerLink="/admin/licensing"> View Licensing Status
        </a>
    </ng-template>
    
</div>